const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:9090"
    : "https://app.cortexial.com";

const env = process.env.NODE_ENV;

export { baseURL, env };



// WEBPACK FOOTER //
// ./src/util/_common.js